import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class TextFiltersService {
  private textFilters: BehaviorSubject<Array<string>>;
  public textFilters$: Observable<Array<string>>;

  constructor() {
    this.textFilters = new BehaviorSubject<Array<string>>([]);
    if (JSON.parse(localStorage.getItem('textFilters')) != undefined || JSON.parse(localStorage.getItem('textFilters')) != null) {
      this.textFilters.next(JSON.parse(localStorage.getItem('textFilters')));
    }
    this.textFilters$ = this.textFilters.asObservable();
  }

  public initFilters(filters: Array<string>) {
    localStorage.setItem('textFilters', JSON.stringify(filters));
    this.textFilters.next(filters);
  }

  public updateFilters(filters: string) {
    if (this.textFilters.value.includes(filters.toLowerCase())) return;
    this.textFilters.next([...this.textFilters.value, filters.toLowerCase()]);
    localStorage.setItem('textFilters', JSON.stringify(this.textFilters.value));
  }

  public deleteFilters(filter: string) {
    this.textFilters.next(this.textFilters.value.filter(res => res !== filter));
    localStorage.setItem('textFilters', JSON.stringify(this.textFilters.value));
  }

  public clearStorage() {
    localStorage.removeItem('textFilters');
    this.textFilters.next([]);
  }
}